var module = angular.module('octopusApp.environments');

module.directive('tentacleActiveEndpoint', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      endpoint: '='
    },
    templateUrl: 'areas/environments/views/endpoints/tentacle_active_endpoint.html',
    controller: function($scope, octopusRepository, busy) {
      var isLoading = $scope.isLoading = busy.create();
      isLoading.promise(octopusRepository.Certificates.getOctopusCertificate().then(function(certificate) {
        $scope.serverThumbprint = certificate.Thumbprint;
      }));
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/tentacle_active_endpoint.js
// module id = 428
// module chunks = 1